import { render } from "./Pagination.vue?vue&type=template&id=6bc2d9c4"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=6bc2d9c4&lang=css"
script.render = render

export default script